<template>
  <section id="team" class="team-wrap pb-75">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style3 text-center mb-40">
            <span>Our Doctors</span>
            <h2>
              We provide <span>Exceptional Medical</span> Care For Our Patients
            </h2>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div
          class="col-xl-4 col-lg-4 col-md-6"
          v-for="team in teams"
          :key="team.id"
        >
          <div class="team-card style6">
            <div class="team-img">
              <img :src="team.image" alt="Image" />

              <div class="member-social">
                <i class="flaticon-share-1"></i>
                <ul class="social-profile list-style style1">
                  <li>
                    <a target="_blank" href="https://facebook.com">
                      <i class="ri-facebook-fill"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://twitter.com">
                      <i class="ri-twitter-fill"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://linkedin.com">
                      <i class="ri-linkedin-fill"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://instagram.com">
                      <i class="ri-pinterest-fill"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="team-info">
              <h3>{{ team.name }}</h3>
              <span>{{ team.designation }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OurDoctors",
  data: () => ({
    teams: [
      {
        id: 1,
        datadelay: "200",
        image: require("../../assets/images/team/member-12.jpg"),
        name: "Dr. Ken Moris",
        designation: "Urology Efficient",
      },
      {
        id: 2,
        datadelay: "300",
        image: require("../../assets/images/team/member-13.jpg"),
        name: "Dr. Michel Jhonson",
        designation: "Cardiology Efficient",
      },
      {
        id: 3,
        datadelay: "400",
        image: require("../../assets/images/team/member-9.jpg"),
        name: "Dr. Luiz Frank",
        designation: "Neurosurgery Efficient",
      },
    ],
  }),
});
</script>